import dynamic from "next/dynamic";

import { useGetDeviceType } from "_common/hooks/global";
import { useGetAdConfig }   from "_common/hooks/global";
import { useGetDarkMode }   from "_common/hooks/global";
import useDfpSlot           from "_components/features/ads/useDfpSlot";

const Advertisement = dynamic ( () => import ( "_components/features/ads/bannerMobile" ) );

const component = () => {
	const { LIVE_STREAM_COMPANION_MWEB: config } = useGetAdConfig ();
	const darkMode                               = useGetDarkMode ();
	const deviceType                             = useGetDeviceType ();
	const isMobile                               = deviceType === "mobile";

	if ( !config?.enabled || !isMobile )
		return null;

	if ( config?.adManager === "vmax" )
		return (
			<Advertisement id = { config?.adUnitId } />
		);

	const path = darkMode ? config?.slotId?.dark : config?.slotId?.light;

	return (
		<AdSlot
			path = { path }
			size = { config?.size }
		/>
	);
};

const AdSlot = ( { path, size } ) => {
	const comp = useDfpSlot ( {
		id: "gpt-passback-below-player",
		path,
		size
	} );

	return comp;
};

export default component;
